import React from "react";
import styled, { css } from "styled-components";
import { Col, Row } from "components/bootstrap";
const ErrorsContainer = styled(Row)(
  ({ theme }) => css`
    margin-top: ${theme.spacings.xs};
  `
);
const Error = styled.p(
  ({ theme }) => css`
    color: ${theme.colors.variant.danger};
    margin-top: ${theme.spacings.xs};
    margin-bottom: ${theme.spacings.xs};
  `
);
const Errors = ({ objectWithErrors = void 0 }) => {
  var _a;
  if (!objectWithErrors) {
    return null;
  }
  if (!objectWithErrors.errors) {
    return null;
  }
  if (!(objectWithErrors.errors.length > 0)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(ErrorsContainer, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, (_a = objectWithErrors == null ? void 0 : objectWithErrors.errors) == null ? void 0 : _a.map((error) => /* @__PURE__ */ React.createElement(Row, { key: error }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Error, null, error))))));
};
export default Errors;
